import { actorSchema, sourceSchema } from "@sentry/junior-plugin-api";
import { z } from "zod";

export const MEMORY_KINDS = ["preference", "procedure", "knowledge"] as const;

export const MEMORY_SCOPES = ["private", "public"] as const;
export const MEMORY_SUBJECT_TYPES = [
  "user",
  "conversation",
  "general",
] as const;
// Durable attribution follows Source kind, including dashboard roots.
export const MEMORY_SOURCE_PLATFORMS = ["slack", "local", "web"] as const;
export const MEMORY_EMBEDDING_METRICS = ["cosine"] as const;
export const MEMORY_EMBEDDING_DIMENSIONS = 1536;

export type MemoryKind = (typeof MEMORY_KINDS)[number];
export type MemoryScope = (typeof MEMORY_SCOPES)[number];
export type MemorySubjectType = (typeof MEMORY_SUBJECT_TYPES)[number];
export type MemorySourcePlatform = (typeof MEMORY_SOURCE_PLATFORMS)[number];
export type MemoryEmbeddingMetric = (typeof MEMORY_EMBEDDING_METRICS)[number];

const nonEmptyStringSchema = z.string().min(1);

/** Host data used to set memory access, subject, and source. */
export const memoryRuntimeContextSchema = z
  .object({
    conversationId: nonEmptyStringSchema.optional(),
    locationId: nonEmptyStringSchema.optional(),
    actor: actorSchema.optional(),
    source: sourceSchema,
    /** User linked to the active Actor. */
    userId: nonEmptyStringSchema.optional(),
  })
  .strict();

export type MemoryRuntimeContext = z.output<typeof memoryRuntimeContextSchema>;
